// @Version: 1.0.4
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { ProjectModule } from 'src/app/project/project.module';
import { DesignService } from 'src/app/shared/services/design/design.service';
import { of } from 'rxjs';
import { catchError, concatMap, map} from 'rxjs/operators';
import { JsonHelpersService } from 'src/app/shared/services/helpers/json-helpers.service';
import { DESIGNLANG } from 'src/app/shared/services/design/design.model';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { ApiModule } from 'build/openapi/shared';
import { SharedOpenapiCastService } from 'build/project/openapi-cast/shared/shared-openapi-cast.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SharedModule } from 'src/app/shared/shared.module';
import { provideRouter, withDebugTracing, withRouterConfig } from '@angular/router';
import { routes } from 'src/app/app-routing.module';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

const initializeAppFactory = () => {
   const sTranslate: TranslateService = inject(TranslateService);
   const sDesign: DesignService = inject(DesignService);
   const sSharedOpenapi: SharedOpenapiCastService = inject(SharedOpenapiCastService);

   sTranslate.addLangs([DESIGNLANG.DEFAULT, DESIGNLANG.PROD]);
   sTranslate.setDefaultLang(DESIGNLANG.DEFAULT);
   sTranslate.use(DESIGNLANG.DEFAULT);
   sDesign.setOption(-1);

   if (location.href.indexOf('?') > -1 && location.href.indexOf('#') > -1 && location.href.indexOf('?') < location.href.indexOf('#')) {
      const url = location.href.substring(0, location.href.indexOf('?')) + location.href.substring(location.href.indexOf('#')) +  location.href.substring(location.href.indexOf('?'), location.href.indexOf('#'));
      location.href = `${url}`
   }
   return sSharedOpenapi.setIsConnected().pipe(
      concatMap(value => sSharedOpenapi.checkConnection ? sTranslate.use(DESIGNLANG.PROD) : of(false)),
      map(value => true),
      catchError(error => {
         console.error("ERROR", error)
         return of(true)
      })
   )
}

@NgModule({ 
   declarations: [
      AppComponent
   ],
   exports: [
      TranslateModule,
      SharedModule
   ],
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
   bootstrap: [AppComponent], 
   imports: [
      CommonModule,
      BrowserModule,
      BrowserAnimationsModule,
      ProjectModule,

      TranslateModule.forRoot({
         loader: {
            provide: TranslateLoader,
            useClass: DesignService,
            deps: [SharedOpenapiCastService, JsonHelpersService, HttpClient],
         },
      }),
      ApiModule
   ], 
   providers: [
      provideHttpClient(),
      provideRouter(routes,        
         //withDebugTracing(),        
         withRouterConfig({paramsInheritanceStrategy: 'always',     urlUpdateStrategy: 'eager'}))    
,
      Location,
      provideAppInitializer(initializeAppFactory),
      { 
         provide: LocationStrategy, 
         useClass: HashLocationStrategy 
      },
      provideHttpClient(withInterceptorsFromDi()),
      { 
         provide:  MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, 
         useValue:{hideSingleSelectionIndicator: true} 
      },
      {
         provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
         useValue: {MAT_FORM_FIELD_DEFAULT_OPTIONS}
      }   ]
})
export class AppModule { 
}